import Navbar from "../components/Navbar";
import Blog from "../components/Blog";
import { Footer } from "../components/Footer";
import Contact from "../components/Contact";

export default function Blogs() {
  return (
    <>
      <Navbar />
      <Blog />
      <Contact/>
    
      <Footer />
    </>
  );
}